import React, {useState, useEffect} from 'react';
import {Button, Spin} from 'antd';
import * as XLSX from 'xlsx';
import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate';

const NctReports = ({data, fromDate, toDate}) => {
  const [exportButton, setExportButton] = useState(true);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    // set the export button to false, if data is there it will change to true or else it will be false
    setExportButton(false);
    if (data.length === 0) {
      setExportButton(true);
    }
    // console.log(fromDate, toDate);
  }, [data]);


  const createDownLoadNctData = () => {
    setDownloading(true);
    if (downloading === false) {
      // Downloading the NctReportExport Report
      handleNctReportExport().then(url => {
        // Calling the handleNctReportExport Format and converting it into Excel
        const downloadAnchorNode = document.createElement('a');
        downloadAnchorNode.setAttribute('href', url);
        downloadAnchorNode.setAttribute(
          'download',
          `ServiceRequestReport_${fromDate}_${toDate}.xls`,
        );
        downloadAnchorNode.click();
        downloadAnchorNode.remove();
      });
    } else {
      alert('please wait, while the data is being processed');
    }
  };

  const workbook2blob = workbook => {
    // Conversion of data to excel format
    const wopts = {
      bookType: 'xlsx',
      bookSST: false,
      type: 'binary',
    };

    const wbout = XLSX.write(workbook, wopts);

    const blob = new Blob([s2ab(wbout)], {
      type: 'application/octet-stream',
    });

    return blob;
  };

  const s2ab = s => {
    // Conversion of data to excel format and sorting of the data
    const buf = new ArrayBuffer(s.length);

    const view = new Uint8Array(buf);

    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i);
    }

    return buf;
  };

  const handleNctReportExport = () => {
    // Creating the NCT Report Excel Format
    const title = [
      {
        A: `Service Request Report of  "${data[0].clientname}"  as of Date From "${fromDate}" to "${toDate}" `,
      },
      {},
    ];

    let table = [
      {
        A: 'Sno',
        B: 'Client Name',
        C: 'Scheme Name',
        D: 'Investment Class',
        E: 'Transaction Date',
        F: 'Ticket Number',
        G: 'Account No',
        H: 'Investor Name',
        I: 'Requested By',
        J: 'Service Request Category',
        K: 'Service Request',
        L: 'Endorsed By',
        M: 'Processed Date',
        N: 'Remarks',
        O: 'Status',
        P: 'Internal Change',
        Q: 'Service Request Source',
        R: 'Ageing',
      },
    ];

    let Total = [
      {
        A: '', // this will be for total and it will be empty
      },
    ];

    //Pushing data to tables
    for (let i = 0; i < data.length; i++) {
      table.push({
        A: data[i].sno,
        B: data[i].clientname,
        C: data[i].fund_name,
        D: data[i].class_name,
        E: data[i].transaction_date,
        F: data[i].erp_reference_ticket_num,
        G: `${' ' + data[i].account_number}`,
        H: data[i].investor_name,
        I: data[i].requested_by_name,
        J: data[i].category_name,
        K: data[i].subject_name,
        L: data[i].endoeresed_by,
        M: data[i].processed_date,
        N: data[i].remark,
        O: data[i].status,
        P: data[i].internal_change,
        Q: data[i].source_type_name,
        R: data[i].nct_ageing,
      });
    }

    Total.push({
      A: 'Total Transaction',
      B: data.length,
    });

    table = [{A: ''}]
      .concat([''])
      .concat([''])
      .concat(table)
      .concat([''])
      .concat([''])
      .concat(Total);

    const finalData = [...title, ...table];

    const wb = XLSX.utils.book_new();

    const sheet = XLSX.utils.json_to_sheet(finalData, {
      skipHeader: true,
    });

    XLSX.utils.book_append_sheet(wb, sheet, 'Service Report');

    const workbookBlob = workbook2blob(wb);

    var headerIndexes = [];
    finalData.forEach((data, index) =>
      data['A'] === 'Sno' ? headerIndexes.push(index) : null,
    );

    const dataInfo = {
      titleCell: 'A1',
      titleRange: 'A1:D2',
      tbodyRange: `A2:CZ${finalData.length}`,
      theadRange:
        headerIndexes?.length >= 1
          ? `A${headerIndexes[0] + 1}:R${headerIndexes[0] + 1}`
          : null,
    };

    return addStyle(workbookBlob, dataInfo);
  };

  const addStyle = (workbookBlob, dataInfo) => {
    // Styling the excel sheet
    return XlsxPopulate.fromDataAsync(workbookBlob).then(workbook => {
      workbook.sheets().forEach(sheet => {
        sheet.usedRange().style({
          fontFamily: 'Arial',
          verticalAlignment: 'center',
        });

        sheet.column('A').width(25);
        sheet.column('B').width(25);
        sheet.column('C').width(25);
        sheet.column('D').width(25);
        sheet.column('E').width(25);
        sheet.column('F').width(25);
        sheet.column('G').width(35);
        sheet.column('H').width(40);
        sheet.column('I').width(30);
        sheet.column('J').width(45);
        sheet.column('K').width(45);
        sheet.column('L').width(45);
        sheet.column('M').width(45);
        sheet.column('N').width(45);
        sheet.column('O').width(45);
        sheet.column('P').width(45);
        sheet.column('Q').width(45);
        sheet.column('R').width(45);

        sheet.range(dataInfo.titleRange).merged(true).style({
          bold: true,
          horizontalAlignment: 'center',
          verticalAlignment: 'center',
          border: true,
        });

        if (dataInfo.tbodyRange) {
          sheet.range(dataInfo.tbodyRange).style({
            horizontalAlignment: 'center',
          });
        }

        sheet.range(dataInfo.theadRange).style({
          bold: true,
          horizontalAlignment: 'center',
          border: true,
        });
      });

      return workbook
        .outputAsync()
        .then(workbookBlob => URL.createObjectURL(workbookBlob));
    });
  };

  return (
    <div>
      {downloading ? (
        <Spin size="medium" />
      ) : (
        <Button
          onClick={() => {
            createDownLoadNctData();
          }}
          disabled={exportButton}
          loading={downloading}
          style={{
            width: '140px',
            height: '33px',
            backgroundColor: '#A3020C',
            color: 'white',
            borderRadius: 5,
          }}>
          Export as Excel
        </Button>
      )}
    </div>
  );
};

export default NctReports;
